import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import type { AppShellNavigationFooterProps } from "../../../../../../shared/frontend/layout/AppShellNavigationFooter";
import { platformNavigationFooter } from "../../../../../../shared/frontend/layout/appShellFooterTranslations";
import { useAuth } from "../auth/useAuth";
import { Permissions } from "../constants/permissions";
import { useI18n } from "../i18n/useI18n";
import { ROUTE_BILLING } from "../constants/appRoutes";

const PLAN_STALE_MS = 5 * 60_000;

type BillingWorkspace = { subscription?: { planName?: string | null } | null };

/** Daten für den gemeinsamen Fußbereich der Navigation: aktueller Tarif und die gemeinsame Rechtsseite. */
export function useNavigationFooter(): AppShellNavigationFooterProps {
  const auth = useAuth();
  const { lang } = useI18n();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const canChangeBilling = auth.hasAnyPermission(Permissions.BillingWrite);
  const workspace = useQuery({
    queryKey: ["billing-workspace-plan", auth.info?.tenantId],
    queryFn: () => auth.api.get<BillingWorkspace>("/api/v1/billing/workspace"),
    enabled: canChangeBilling,
    staleTime: PLAN_STALE_MS,
  });
  const planName = workspace.data?.subscription?.planName?.trim() || null;
  return platformNavigationFooter(lang, {
    pathname,
    navigate,
    plan: canChangeBilling ? { planName, current: pathname === ROUTE_BILLING, onClick: () => navigate(ROUTE_BILLING) } : undefined,
  });
}
